import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  deviceType?: 'jobsite_conditions_monitor' | 'lorawan_sensor'
  options?: Omit<UseQueryOptions<string[], Error>, 'queryKey' | 'queryFn'>
}

export const useStagingDevicesRequest = ({ options, deviceType }: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<string[], Error>(
    [Entities.Configuration, 'get-staging-devices', deviceType || ''],
    async () => {
      const { data } = await api.v1AdminConfigurationSensorAllocationGet(deviceType)
      return data as string[]
    },
    options
  )
}
